<template>
  <div>
    <HomeInicio />
    
    <div class="container" v-if="paquete === 4">
      <h2>Mi álbum de fotos</h2>

      

      <div v-if="fotos.length > 0" class="mobile-gallery">
        <div class="gallery-grid">
          <div v-for="(foto) in fotos" 
               :key="foto.id_subirfotos" 
               class="gallery-item"
               @click="abrirModal(foto)">
            <img :src="foto.url_foto" alt="Foto" class="gallery-img" />
            <div class="photo-overlay">
              <i class="fas fa-expand"></i>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="empty-gallery">
        <i class="fas fa-images"></i>
        <p>No hay fotos disponibles</p>
        <small></small>
      </div>
    </div>

    <div v-else class="upgrade-message">
      <div class="upgrade-content">
        <i class="fas fa-crown"></i>
        <h3>Contenido Premium</h3>
        <p>Esta sección está disponible en nuestro paquete premium</p>
        <button @click="goToUpgrade">Actualizar paquete</button>
      </div>
    </div>

    <!-- Modal mejorado -->
    <div v-if="modalAbierto" class="modal" @click.self="cerrarModal">
      <div class="modal-content">
        <div class="modal-header">
          <span class="photo-counter">{{ fotoIndex + 1 }} / {{ fotos.length }}</span>
          <div class="modal-actions">
            <a :href="fotoActual.url_foto" download class="download-btn">
              <i class="fas fa-download"></i>
            </a>
            <button @click="cerrarModal" class="close-btn">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        
        <div class="modal-body">
          <img :src="fotoActual.url_foto" alt="Foto grande" class="modal-img" />
          
          <button @click="anteriorFoto" class="nav-btn prev">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button @click="siguienteFoto" class="nav-btn next">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
        
        <div class="modal-footer">
          <p class="photo-date">Agregada el {{ formatDate(fotoActual.fecha_subida) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fotosUrl from "../api";
import HomeInicio from "@/components/HomeInicio.vue";
import Swal from "sweetalert2";

export default {
  name: "album-fotos",
  components: {
    HomeInicio,
  },
  data() {
    return {
      fotos: [],
      paquete: Number(localStorage.getItem('paquete')),
      fotoActual: null,
      modalAbierto: false,
    };
  },
  computed: {
    fotoIndex() {
      return this.fotos.findIndex(f => f.id_subirfotos === this.fotoActual?.id_subirfotos);
    }
  },
  mounted() {
    this.obtenerFotos();
  },
  methods: {
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('es-ES', options);
    },
    abrirModal(foto) {
      this.fotoActual = foto;
      this.modalAbierto = true;
      document.body.style.overflow = 'hidden';
    },
    cerrarModal() {
      this.modalAbierto = false;
      document.body.style.overflow = 'auto';
    },
    siguienteFoto() {
      const nextIndex = (this.fotoIndex + 1) % this.fotos.length;
      this.fotoActual = this.fotos[nextIndex];
    },
    anteriorFoto() {
      const prevIndex = (this.fotoIndex - 1 + this.fotos.length) % this.fotos.length;
      this.fotoActual = this.fotos[prevIndex];
    },
    goToUpgrade() {
      this.$router.push('/paquetes');
    },
    async obtenerFotos() {
      try {
        const idFestejada = localStorage.getItem("id_festejada");
        if (idFestejada) {
          const response = await fetch(`${fotosUrl}/api2/subirfotos?id_festejada=${idFestejada}`);
          const data = await response.json();
          this.fotos = data;
        }
      } catch (error) {
        console.error("Error al obtener fotos:", error);
      }
    },
    async eliminarFotos() {
      const { isConfirmed } = await Swal.fire({
        title: '¿Eliminar todas las fotos?',
        text: "Esta acción no se puede deshacer",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (isConfirmed) {
        try {
          const idFestejada = localStorage.getItem("id_festejada");
          if (idFestejada) {
            await fetch(`${fotosUrl}/api2/eliminarFotos?id_festejada=${idFestejada}`, {
              method: "DELETE",
            });
            this.fotos = [];
            Swal.fire('¡Eliminadas!', 'Todas las fotos han sido eliminadas.', 'success');
          }
        } catch (error) {
          Swal.fire('Error', 'Hubo un problema al eliminar las fotos.', 'error');
        }
      }
    },
  },
};
</script>
<style scoped>
/* Estilos base */
.container {
  padding: 15px;
  margin-top: 0px;
}

h2 {
  font-family: 'Playfair Display', serif;
  font-size: 1.8rem;
  color: #4a3f42;
  text-align: center;
  margin-bottom: 20px;
}

/* Botón eliminar */
.eliminar-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #ff4d4d;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  margin: 0 auto 20px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.eliminar-btn:hover {
  background-color: #e60000;
}

/* Galería estilo móvil */
.mobile-gallery {
  width: 100%;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
}

.gallery-item {
  position: relative;
  aspect-ratio: 1/1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  cursor: pointer;
}

.gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-item:hover .gallery-img {
  transform: scale(1.05);
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: white;
  font-size: 18px;
}

.gallery-item:hover .photo-overlay {
  opacity: 1;
}

/* Mensaje sin fotos */
.empty-gallery {
  text-align: center;
  padding: 40px 20px;
  color: #888;
}

.empty-gallery i {
  font-size: 50px;
  margin-bottom: 15px;
  color: #ddd;
}

.empty-gallery p {
  font-size: 16px;
  margin-bottom: 5px;
}

.empty-gallery small {
  font-size: 14px;
}

/* Modal para móviles */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 10px;
}

.modal-content {
  width: 100%;
  background: #111;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: rgba(0,0,0,0.5);
  color: white;
}

.photo-counter {
  font-size: 13px;
  opacity: 0.8;
}

.modal-actions {
  display: flex;
  gap: 12px;
}

.download-btn, .close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.modal-body {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.modal-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 35px;
  height: 35px;
  background: rgba(255,255,255,0.2);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}

.modal-footer {
  padding: 12px;
  text-align: center;
  background: rgba(0,0,0,0.5);
  color: #aaa;
  font-size: 12px;
}

/* Ajustes para pantallas más grandes */
@media (min-width: 768px) {
  .gallery-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }
  
  .modal-content {
    max-width: 600px;
  }
  
  .nav-btn {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
}
</style>